module.exports = __webpack_public_path__ + "static/media/evangelizacao.36676ad4.md";